import styled from 'styled-components';

export const TooltipWrapper = styled.div`
  position: relative;
  display: inline-block;
  cursor: pointer;
`;

export const TooltipContainer = styled.div<{
  $position: 'top' | 'bottom' | 'left' | 'right';
  $isOpen: boolean;
}>`
  position: absolute;
  z-index: 1000;
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  max-width: 180px;
  width: max-content;
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease-in-out,
    visibility 0.2s ease-in-out;
  pointer-events: ${({ $isOpen }) => ($isOpen ? 'auto' : 'none')};

  ${({ $position }) => {
    switch ($position) {
      case 'top':
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'bottom':
        return `
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
      case 'left':
        return `
          right: 100%;
          top: 50%;
          transform: translateY(-50%);
        `;
      case 'right':
        return `
          left: 100%;
          top: 50%;
          transform: translateY(-50%);
        `;
      default:
        return `
          bottom: 100%;
          left: 50%;
          transform: translateX(-50%);
        `;
    }
  }}
`;

export const TooltipContent = styled.div`
  background-color: #d9ceaf;
  color: #493f22;
  padding: 8px;
  border-radius: 4px;
  line-height: 1.4;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  word-wrap: break-word;
  overflow-wrap: break-word;
`;

export const Tooltip = styled.div`
  word-wrap: break-word;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const CloseButton = styled.img`
  width: 13px;
  height: 13px;
  background-color: #ad9552;
  border-radius: 50%;
  cursor: pointer;
`;
